import pick from 'lodash/pick';

import { types as sdkTypes, createImageVariantConfig } from '../../util/sdkLoader';
import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { createResume, insertCollection, sendGridEmail, transactionLineItems, updateCollection, updateUserListing } from '../../util/api';
import * as log from '../../util/log';
import { denormalisedResponseEntities } from '../../util/data';
import { findNextBoundary, getStartOf, monthIdString } from '../../util/dates';
import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
  parse,
} from '../../util/urlHelpers';
import { getProcess, isBookingProcessAlias } from '../../transactions/transaction';
import { fetchCurrentUser, fetchCurrentUserHasOrdersSuccess } from '../../ducks/user.duck';
import { transitions } from '../../transactions/transactionProcessBooking';
import { getFollowCompanyData } from '../FollowCompanyPage/FollowCompanyPage.duck';
import { fetchParentJobRoles } from '../EditListingPage/EditListingPage.duck';
import { getSavedNotes } from '../SavedNotesPage/SavedNotesPage.duck';
const { UUID } = sdkTypes;

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/ListingPage/SET_INITIAL_VALUES';

export const SHOW_LISTING_REQUEST = 'app/ListingPage/SHOW_LISTING_REQUEST';
export const SHOW_LISTING_SUCCESS = 'app/ListingPage/SHOW_LISTING_SUCCESS';
export const SHOW_LISTING_ERROR = 'app/ListingPage/SHOW_LISTING_ERROR';

export const SHOW_PORTFOLIO_SUCCESS = 'app/ListingPage/SHOW_PORTFOLIO_SUCCESS';

export const FETCH_REVIEWS_REQUEST = 'app/ListingPage/FETCH_REVIEWS_REQUEST';
export const FETCH_REVIEWS_SUCCESS = 'app/ListingPage/FETCH_REVIEWS_SUCCESS';
export const FETCH_REVIEWS_ERROR = 'app/ListingPage/FETCH_REVIEWS_ERROR';

export const FETCH_TIME_SLOTS_REQUEST = 'app/ListingPage/FETCH_TIME_SLOTS_REQUEST';
export const FETCH_TIME_SLOTS_SUCCESS = 'app/ListingPage/FETCH_TIME_SLOTS_SUCCESS';
export const FETCH_TIME_SLOTS_ERROR = 'app/ListingPage/FETCH_TIME_SLOTS_ERROR';

export const FETCH_LINE_ITEMS_REQUEST = 'app/ListingPage/FETCH_LINE_ITEMS_REQUEST';
export const FETCH_LINE_ITEMS_SUCCESS = 'app/ListingPage/FETCH_LINE_ITEMS_SUCCESS';
export const FETCH_LINE_ITEMS_ERROR = 'app/ListingPage/FETCH_LINE_ITEMS_ERROR';

export const SEND_INQUIRY_REQUEST = 'app/ListingPage/SEND_INQUIRY_REQUEST';
export const SEND_INQUIRY_SUCCESS = 'app/ListingPage/SEND_INQUIRY_SUCCESS';
export const SEND_INQUIRY_ERROR = 'app/ListingPage/SEND_INQUIRY_ERROR';

export const CREATE_RESUME_REQUEST = 'app/ListingPage/CREATE_RESUME_REQUEST';
export const CREATE_RESUME_SUCCESS = 'app/ListingPage/CREATE_RESUME_SUCCESS';
export const CREATE_RESUME_ERROR = 'app/ListingPage/CREATE_RESUME_ERROR';

export const INSERT_COLLECTION_REQUEST = 'app/ListingPage/INSERT_COLLECTION_REQUEST';
export const INSERT_COLLECTION_SUCCESS = 'app/ListingPage/INSERT_COLLECTION_SUCCESS';
export const INSERT_COLLECTION_ERROR = 'app/ListingPage/INSERT_COLLECTION_ERROR';

// ================ Reducer ================ //
const resultIds = data => data.data.map(l => l.id);

const initialState = {
  id: null,
  authorListingIds: [],
  showListingError: null,
  reviews: [],
  fetchReviewsError: null,
  monthlyTimeSlots: {
    // '2022-03': {
    //   timeSlots: [],
    //   fetchTimeSlotsError: null,
    //   fetchTimeSlotsInProgress: null,
    // },
  },
  lineItems: null,
  fetchLineItemsInProgress: false,
  fetchLineItemsError: null,
  sendInquiryInProgress: false,
  sendInquiryError: null,
  inquiryModalOpenForListingId: null,
  createResumeInProgress: false,
  resumeURL: null,
  createResumeError: null,
  showPortfolio: false,

  insertCollectionInProgress: false,
  insertCollectionError: null,
  insertCollectionData: null,
};

const listingPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case SHOW_LISTING_REQUEST:
      return { ...state, id: payload.id, showListingError: null };
    case SHOW_LISTING_SUCCESS:
      return { ...state, authorListingIds: resultIds(payload.data) }
    case SHOW_LISTING_ERROR:
      return { ...state, showListingError: payload };

    case FETCH_REVIEWS_REQUEST:
      return { ...state, fetchReviewsError: null };
    case FETCH_REVIEWS_SUCCESS:
      return { ...state, reviews: payload };
    case FETCH_REVIEWS_ERROR:
      return { ...state, fetchReviewsError: payload };
    case SHOW_PORTFOLIO_SUCCESS:
      return { ...state, showPortfolio: true, portfolioId: payload?.id };


    case FETCH_TIME_SLOTS_REQUEST: {
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [payload]: {
          ...state.monthlyTimeSlots[payload],
          fetchTimeSlotsError: null,
          fetchTimeSlotsInProgress: true,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_SUCCESS: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          timeSlots: payload.timeSlots,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_ERROR: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          fetchTimeSlotsError: payload.error,
        },
      };
      return { ...state, monthlyTimeSlots };
    }

    case FETCH_LINE_ITEMS_REQUEST:
      return { ...state, fetchLineItemsInProgress: true, fetchLineItemsError: null };
    case FETCH_LINE_ITEMS_SUCCESS:
      return { ...state, fetchLineItemsInProgress: false, lineItems: payload };
    case FETCH_LINE_ITEMS_ERROR:
      return { ...state, fetchLineItemsInProgress: false, fetchLineItemsError: payload };

    case SEND_INQUIRY_REQUEST:
      return { ...state, sendInquiryInProgress: true, sendInquiryError: null };
    case SEND_INQUIRY_SUCCESS:
      return { ...state, sendInquiryInProgress: false };
    case SEND_INQUIRY_ERROR:
      return { ...state, sendInquiryInProgress: false, sendInquiryError: payload };
    case CREATE_RESUME_REQUEST:
      return { ...state, createResumeInProgress: true, createResumeError: null };
    case CREATE_RESUME_SUCCESS:
      return { ...state, createResumeInProgress: false, resumeURL: payload };
    case CREATE_RESUME_ERROR:
      return { ...state, createResumeInProgress: false, createResumeError: payload };
    case INSERT_COLLECTION_REQUEST:
      return { ...state, insertCollectionInProgress: payload.type, insertCollectionError: null };
    case INSERT_COLLECTION_SUCCESS:
      return { ...state, insertCollectionInProgress: false, insertCollectionData: payload };
    case INSERT_COLLECTION_ERROR:
      return {
        ...state,
        insertCollectionInProgress: false,
        insertCollectionError: payload
      };
    default:
      return state;
  }
};

export default listingPageReducer;

// ================ Action creators ================ //

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

export const showListingRequest = id => ({
  type: SHOW_LISTING_REQUEST,
  payload: { id },
});

export const showListingSuccess = response => ({
  type: SHOW_LISTING_SUCCESS,
  payload: { data: response.data },
});
export const showListingError = e => ({
  type: SHOW_LISTING_ERROR,
  error: true,
  payload: e,
});

export const showPortfolioSuccess = (response, id) => ({
  type: SHOW_PORTFOLIO_SUCCESS,
  payload: { data: response, id },
});

export const fetchReviewsRequest = () => ({ type: FETCH_REVIEWS_REQUEST });
export const fetchReviewsSuccess = reviews => ({ type: FETCH_REVIEWS_SUCCESS, payload: reviews });
export const fetchReviewsError = error => ({
  type: FETCH_REVIEWS_ERROR,
  error: true,
  payload: error,
});

export const fetchTimeSlotsRequest = monthId => ({
  type: FETCH_TIME_SLOTS_REQUEST,
  payload: monthId,
});
export const fetchTimeSlotsSuccess = (monthId, timeSlots) => ({
  type: FETCH_TIME_SLOTS_SUCCESS,
  payload: { timeSlots, monthId },
});
export const fetchTimeSlotsError = (monthId, error) => ({
  type: FETCH_TIME_SLOTS_ERROR,
  error: true,
  payload: { monthId, error },
});

export const fetchLineItemsRequest = () => ({ type: FETCH_LINE_ITEMS_REQUEST });
export const fetchLineItemsSuccess = lineItems => ({
  type: FETCH_LINE_ITEMS_SUCCESS,
  payload: lineItems,
});
export const fetchLineItemsError = error => ({
  type: FETCH_LINE_ITEMS_ERROR,
  error: true,
  payload: error,
});

export const sendInquiryRequest = () => ({ type: SEND_INQUIRY_REQUEST });
export const sendInquirySuccess = () => ({ type: SEND_INQUIRY_SUCCESS });
export const sendInquiryError = e => ({ type: SEND_INQUIRY_ERROR, error: true, payload: e });

export const createResumeRequest = () => ({ type: CREATE_RESUME_REQUEST });
export const createResumeSuccess = (data) => ({ type: CREATE_RESUME_SUCCESS, payload: data.cloudinaryUrl });
export const createResumeError = e => ({ type: CREATE_RESUME_ERROR, error: true, payload: e });

export const insertCollectionRequest = (type) => ({ type: INSERT_COLLECTION_REQUEST, payload: { type } });
export const insertCollectionSuccess = () => ({ type: INSERT_COLLECTION_SUCCESS });
export const insertCollectionError = () => ({ type: INSERT_COLLECTION_ERROR });

// ================ Thunks ================ //

export const showListing = (listingId, config, newListingParams , isOwn = false) => (dispatch, getState, sdk) => {
  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config?.layout?.listingImage || {};
  const aspectRatio = aspectHeight / aspectWidth;

  dispatch(showListingRequest(listingId));
  dispatch(fetchCurrentUser());
  const params = {
    id: listingId,
    include: ['author', 'author.profileImage', 'images', 'currentStock'],
    'fields.image': [
      // Scaled variants for large images
      'variants.default',
      'variants.scaled-small',
      'variants.scaled-medium',
      'variants.scaled-large',
      'variants.scaled-xlarge',

      // Cropped variants for listing thumbnail images
      `variants.${variantPrefix}`,
      `variants.${variantPrefix}-2x`,
      `variants.${variantPrefix}-4x`,
      `variants.${variantPrefix}-6x`,

      // Social media
      'variants.facebook',
      'variants.twitter',

      // Avatars
      'variants.square-small',
      'variants.square-small2x',
    ],
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-4x`, 1600, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-6x`, 2400, aspectRatio),
  };

  const show = isOwn ? sdk.ownListings.show(params) : sdk.listings.show(params);

  return show
    .then(data => {
      const listingFields = config?.listing?.listingFields;
      const sanitizeConfig = { listingFields };
      // const { currentUser } = getState().user;
      // const { accountType } = (currentUser && currentUser.id && currentUser.attributes.profile.publicData) || {};
      const { listingType } = data.data.data.attributes.publicData || {};
      const isCompany = listingType
        ? listingType == 'company'
        : true;
      dispatch(addMarketplaceEntities(data, sanitizeConfig));

      if (isCompany) {
        const authorId = data.data.data.relationships.author.data.id.uuid;
        return new Promise((resolve) => {
          setTimeout(() => {
            sdk.listings
              .query({ authorId })
              .then(response => {
                dispatch(addMarketplaceEntities(response, sanitizeConfig));
                dispatch(showListingSuccess(response));
                resolve(data);
              })
              .catch(e => {
                // dispatch(searchListingsError(storableError(e)));
                throw e;
              });
          }, 1000);
        });
      }
      return data;
    })
    .catch(e => {
      dispatch(showListingError(storableError(e)));
    });
};

export const fetchReviews = listingId => (dispatch, getState, sdk) => {
  dispatch(fetchReviewsRequest());
  return sdk.reviews
    .query({
      listing_id: listingId,
      state: 'public',
      include: ['author', 'author.profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    })
    .then(response => {
      const reviews = denormalisedResponseEntities(response);
      dispatch(fetchReviewsSuccess(reviews));
    })
    .catch(e => {
      dispatch(fetchReviewsError(storableError(e)));
    });
};

const timeSlotsRequest = params => (dispatch, getState, sdk) => {
  return sdk.timeslots.query(params).then(response => {
    return denormalisedResponseEntities(response);
  });
};

export const fetchTimeSlots = (listingId, start, end, timeZone) => (dispatch, getState, sdk) => {
  const monthId = monthIdString(start, timeZone);

  dispatch(fetchTimeSlotsRequest(monthId));

  // The maximum pagination page size for timeSlots is 500
  const extraParams = {
    perPage: 500,
    page: 1,
  };

  return dispatch(timeSlotsRequest({ listingId, start, end, ...extraParams }))
    .then(timeSlots => {
      dispatch(fetchTimeSlotsSuccess(monthId, timeSlots));
    })
    .catch(e => {
      dispatch(fetchTimeSlotsError(monthId, storableError(e)));
    });
};

export const sendInquiry = (listing, message, userListingId) => (dispatch, getState, sdk) => {
  dispatch(sendInquiryRequest());
  const processAlias = listing?.attributes?.publicData?.transactionProcessAlias || "default-booking/release-1";
  if (!processAlias) {
    const error = new Error('No transaction process attached to listing');
    log.error(error, 'listing-process-missing', {
      listingId: listing?.id?.uuid,
    });
    dispatch(sendInquiryError(storableError(error)));
    return Promise.reject(error);
  }

  const listingId = listing?.id;
  const [processName, alias] = processAlias.split('/');
  const transitions = getProcess(processName)?.transitions;

  const bodyParams = {
    transition: transitions.INQUIRE,
    processAlias,
    params: { listingId },
  };
  return sdk.transactions
    .initiate(bodyParams)
    .then(response => {
      const transactionId = response.data.data.id;

      // Send the message to the created transaction
      return sdk.messages.send({ transactionId, content: message }).then(() => {
        dispatch(sendInquirySuccess());
        dispatch(fetchCurrentUserHasOrdersSuccess(true));
        updateUserListing({ transactionId: transactionId?.uuid, userListingId: userListingId.uuid })
        return transactionId;
      });
    })
    .catch(e => {
      dispatch(sendInquiryError(storableError(e)));
      throw e;
    });
};

export const createResumePDF = (bodyParams) => (dispatch, getState, sdk) => {
  dispatch(createResumeRequest());

  return createResume(bodyParams)
    .then(response => {
      dispatch(createResumeSuccess(response.data));
      return response.data;
    })
    .catch(e => {
      dispatch(createResumeError(storableError(e)));
      throw e;
    });
};

// Helper function for loadData call.
const fetchMonthlyTimeSlots = (dispatch, listing) => {
  const hasWindow = typeof window !== 'undefined';
  const attributes = listing.attributes;
  // Listing could be ownListing entity too, so we just check if attributes key exists
  const hasTimeZone =
    attributes && attributes.availabilityPlan && attributes.availabilityPlan.timezone;

  // Fetch time-zones on client side only.
  if (hasWindow && listing.id && hasTimeZone) {
    const tz = listing.attributes.availabilityPlan.timezone;
    const unitType = attributes?.publicData?.unitType;
    const timeUnit = unitType === 'hour' ? 'hour' : 'day';
    const nextBoundary = findNextBoundary(new Date(), timeUnit, tz);

    const nextMonth = getStartOf(nextBoundary, 'month', tz, 1, 'months');
    const nextAfterNextMonth = getStartOf(nextMonth, 'month', tz, 1, 'months');

    return Promise.all([
      dispatch(fetchTimeSlots(listing.id, nextBoundary, nextMonth, tz)),
      dispatch(fetchTimeSlots(listing.id, nextMonth, nextAfterNextMonth, tz)),
    ]);
  }

  // By default return an empty array
  return Promise.all([]);
};

export const fetchTransactionLineItems = ({ orderData, listingId, isOwnListing }) => dispatch => {
  dispatch(fetchLineItemsRequest());
  transactionLineItems({ orderData, listingId, isOwnListing })
    .then(response => {
      const lineItems = response.data;
      dispatch(fetchLineItemsSuccess(lineItems));
    })
    .catch(e => {
      dispatch(fetchLineItemsError(storableError(e)));
      log.error(e, 'fetching-line-items-failed', {
        listingId: listingId.uuid,
        orderData,
      });
    });
};

export const requestInsertCollection = (data, type) => (dispatch, getState, sdk) => {
  dispatch(insertCollectionRequest(type));

  return type == 'SEND'
    ? sendGridEmail({
      to: data.to,
      dynamic_template_data: {
        ...data
      },
      type: "NOTES"
    }).then(res => dispatch(insertCollectionSuccess(res)))
    : type == 'DELETE'
      ? updateCollection(data)
        .then(res => dispatch(insertCollectionSuccess(res)))
        .catch(err => dispatch(insertCollectionError(err)))
      : type == 'UPDATE'
        ? updateCollection(data)
          .then(res => dispatch(insertCollectionSuccess(res)))
          .catch(err => dispatch(insertCollectionError(err)))
        : insertCollection(data)
          .then(res => dispatch(insertCollectionSuccess(res)))
          .catch(err => dispatch(insertCollectionError(err)));
}

export const checkPendingDeduction = (requestToken = 10) => (dispatch, getState, sdk) => {
  const { currentUser } = getState().user;
  const { id, attributes } = currentUser || {};
  const { uuid: currentUserID } = id || {};
  const { currentSeeds = 0 } = (attributes && attributes?.profile?.protectedData) || {};

  // If user id is not there
  if (!currentUserID) return false;

  try {
    return sdk.transactions
      .query({ userId: currentUserID })
      .then(({ data }) => {
        const transactions = (data && data.data) || [];
        const pendingTokensOfRequestedConnections = transactions.reduce((count, { attributes }) => {
          const lastTransition = attributes?.lastTransition;
          const pendingTokens = attributes?.protectedData?.tokens || 0;

          const isPending =
            (lastTransition == transitions.CONFIRM_PAYMENT ||
              lastTransition == transitions.SAVED_FOR_LATER);

          if (isPending) {
            return count +  pendingTokens;
          }
          return count;
        }, 0);

        return pendingTokensOfRequestedConnections
          ? (currentSeeds - pendingTokensOfRequestedConnections) >= requestToken
          : currentSeeds >= requestToken;
      })
  } catch (error) {
    console.error('Error querying transactions:', error);
    return false;
  }
}

export const updateRole = (params, search, config) => (dispatch, getState, sdk) => {
  const { cloudinaryUrl, listingId, title, highestExperience, specialtiesArray, favouriteToolArray } = params;
  return sdk.ownListings.update({
    id: (listingId)
    , publicData: {
      chatGptQuestions: { url: cloudinaryUrl, title, highestExperience, specialtiesArray, favouriteToolArray }
    }
  }, {
    expand: true
  }).then(() => {
    dispatch(showListing(listingId, config, true))
  })
}

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  const listingId = new UUID(params.id);
  const newListingParams = params;
  // Clear old line-items
  dispatch(setInitialValues({ lineItems: null }));

  const ownListingVariants = [LISTING_PAGE_DRAFT_VARIANT, LISTING_PAGE_PENDING_APPROVAL_VARIANT];
  if (ownListingVariants.includes(params.variant)) {
    return dispatch(showListing(listingId, config, true));
  }

  return Promise.all([
    dispatch(showListing(listingId, config)),
    dispatch(fetchReviews(listingId)),
    (async () => {
      let currentUserr;
      if (getState().user?.currentUser) {
        currentUserr = getState()?.user?.currentUser;

      } else {
        currentUserr = await sdk.currentUser.show()
      }
      const { currentUser } = getState().user || {};

      dispatch(fetchParentJobRoles());
      if (currentUserr?.id?.uuid || currentUserr?.data?.data?.id.uuid) {
        const companyId = currentUserr && currentUserr?.id?.uuid || currentUserr.data.data?.id.uuid;
        const isCompany = currentUserr && currentUserr.id && currentUserr?.attributes?.profile?.publicData.accountType === "company" || currentUserr?.data?.data?.attributes?.profile?.publicData?.accountType === "company";
        return dispatch(getFollowCompanyData(companyId, 1, isCompany, true));
      }
      return null;
    })()
  ])
    .then(response => {
      const listing = response[0]?.data?.data;
      const transactionProcessAlias = listing?.attributes?.publicData?.transactionProcessAlias || '';
      const { currentUser } = getState().user || {};
      const { uuid: currentUserID } = (currentUser && currentUser.id) || {};
      if (currentUserID && listingId) {
        sdk.transactions.query({
          userId: currentUserID,
          listingId: listingId
        })
          .then(({ data }) => {
            if (data && data?.data && data?.data?.length) {
              const result = [];
              data?.data?.forEach(res => {
                const { attributes, id } = res || {};
                const hiringRole = attributes?.protectedData?.hiringRole;
                if ((attributes?.lastTransition === transitions.ACCEPT) || (attributes?.lastTransition === transitions.SAVED_AFTER_ACCEPT) || (attributes?.lastTransition === transitions.SUCCESSFUL_HIRE) && id?.uuid && hiringRole) {
                  result.push({
                    transactionId: id?.uuid,
                    companyId: hiringRole
                  });
                }
              });
              if (result.length) {
                dispatch(showPortfolioSuccess(true, result));
              }
            }
            dispatch(getSavedNotes(parse(search)))
          });
      }

      if (isBookingProcessAlias(transactionProcessAlias)) {
        // Fetch timeSlots.
        // This can happen parallel to loadData.
        // We are not interested to return them from loadData call.
        fetchMonthlyTimeSlots(dispatch, listing);
      }
      return response;
    });
};
